/*
 * @Author: lzh
 * @Date: 2022-09-15 11:29:01
 * @LastEditors: lbh
 * @LastEditTime: 2025-10-21 11:11:42
 * @Description: file content
 */
const hk = {
  语言: "繁體中文",
  name: "姓名",
  info: {
    age: "男",
  },
  "Queue System": "排乜Queue",
  "Getting the number online and receiving notice":
    "唔洗攞飛就可以輪候，輪到你用餐仲會有埋提示呀!",
  "Welcome Guest": "歡迎訪客",
  "Log in for queuing details via Phone number":
    "用手提電話登錄隨時掌握輪候詳情",
  "Sign in_": "請登入",
  Queue: "輪候取號",
  "Currently queuing": "現時輪候總號數",
  "Sorry, there is a temporarily suspension of queue service. Please contact the restaurant staff":
    "唔好意思，當前餐廳已暫停取號服務。如有疑問，請與餐廳職員聯絡",
  "Get number": "取號",
  "Enter your phone number": "電話識別",
  "Enter your last 4-digits of phone number_": "請輸入電話後四位以便識別",
  "Party size": "請選擇人數",
  Confirm: "確認",
  Next: "下一步",
  Cancel: "取消",
  Previous: "返回",
  people: "人",
  awaitPeople: {
    key: "等待 {x} 桌",
  },
  Continue: "繼續輪候",
  "Whatsapp for queue status": "Whatsapp通知你輪候最新動態",
  Notice: "確認通知",
  call_Number: "用餐號",
  call_Current: "當前呼叫",
  call_tables: "桌",
  Waiting: "還需等候",
  "Currently queuing": "現時輪候總號數",
  Restaurant: "餐廳名稱",
  Address: "餐廳地址",
  "Order time": "取號時間",
  "You'll be there soon": "請注意輪候動態，好快到你啦",
  "Cancel line up": "取消輪候",
  "Take number": "重新取號",
  "again Take number": "再次取號",
  "Getting number successfully": "取票成功",
  "WhatsApp prompts the latest trends of queuing": "WhatsApp提示輪候最新動向",
  "Save credentials": "將輪候號碼保存到你的手機上冊,避免號碼遺失",
  Confirm_: "確認",
  promptlySave: "立即保存",
  "Are you sure you want to cancel your queue number?": "真的要取消輪候嗎？",
  "It's time to eat!": "好快有得食啦！",
  beingQueuing: "排隊中",
  call_Calling: "叫號中",
  callPassed: "已過號",
  callSeated: "已入座",
  callCancelled: "已取消",
  awaitXToYour_: {
    key: "*仲有 {X} 位就到你啦！",
  },
  "The number has expired, please get it again": "號碼已失效，請重新取號",
  "Unable to access the page, please check the link for errors":
    "鏈接已失效，請檢查后再試",
  "Unable to access the page, please try again": "該鏈接已失效，請重新掃碼",
  "You have confirmed": "當前賬戶已經完成訂閲，請留意通知!",
  "Sign in and receiving WhatsApp Message": "立即登錄, 即可獲取會員權益",
  "phone number": "電話號碼",
  "Please enter the phone number": "請輸入電話號碼",
  "I have read and agreed": "我已閱讀並同意",
  "Take number succeeded": "取號成功提示",
  "Have dinner": "用餐號",
  "Screenshot to save the number": "爲免遺失，請將號碼<br/>截圖保存到相冊。",
  "will be coming soon": "請注意輪候動態，好快到你啦！",
  "Enter your last 4-digits of phone number": "請輸入手機號後4位！",
  "Enter a correct Phone Number": "請輸入有效的手機號！",
  "Failed to get the number, please try again": "取號失敗，請聯繫工作人員",
  "There are active numbers": "您已取過號",
  "Line up the details": "輪候詳情",
  "No order at present": "暫時沒有訂單",
  "No Data": "暫無數據",
  combo: {
    "Select x": "請選擇 {X} 項",
    "Select x~y": "請選擇 {X}~{Y} 項",
    "Select at least x": "請至少選 {X} 項",
    "x Selected": "已選 {X} 項",
    Required: "必選",
    total: "總計",
    confirm: "確認",
    请至少选x项: "請至少選 {x} 項",
    加配食品: "加配食品",
    停: "停",
  },

  shop: {
    Address: "地址",
    Number: "電話",
    "Special Offer": "餐廳優惠",
    More: "更多",
    "Please select address": "請選擇地址",
    OK: "知道了",
    "Click the button in the upper right corner": "點擊右上角的「...」按鈕",
    'Select "Open in browser"': "選「在瀏覽器中打開」",
    "Open in browser": "在瀏覽器中打開",
    Terms: "使用條款",
    "Privacy Policy": "私隱政策",
    "© 2022 Gingersoft Limited. All rights reserved. No reproduction allowed.":
      " © 2022 薑軟件有限公司 Gingersoft. 版權所有 不得轉載",
    // * 盛記酒家
    "© 2024 Lucky Castle Limited. All rights reserved. No reproduction allowed.":
      "幸堡有限公司. 版權所有 不得轉載",
    "X Sold": "{X}人購賣",
    "X Redeemed": "{X}人領取",
    "X Redeemed2": "已領{X}",
    More2: "點擊查看更多",
    Redeemed: "已領取",
    "Use Now": "去使用",
    "Sold Out": "已售罄",
    Upcoming: "待開始",
    "Redeem Now": "立即領取",
    Details: "查看詳情",
    "Sold Out": "已售罄",
    "Available Restaurants": "適用餐廳",
    "Business Hours": "營業時間",
    Order: "我的訂單",
    Coupon: "我的優惠券",
    Bookmark: "我的收藏",
    Language: "選擇語言",
    Logout: "登出",
    Login: "未登錄",
    "Failed to obtain address!": "獲取地址失敗！",
    Delivery: "外送",
    "Self pick up": "自取",
    "Cold Chain Delivery": "凍鏈派送",
    "No available restaurants!": "暫無可用餐廳!",
    Success: "領取成功",
    "Please go to my account-coupons to check": "請前往我的帳戶-優惠券中查看",
  },
  orderDetail: {
    "Payment Method:": "支付方式：",
    "Payment Method": "支付方式",
    "Use Now": "使用優惠券",
    "Service Fee:": "服務費：",
    "Bill Decimal:": "賬單小數：",
    "Total X items": "共{X}份",
    Total: "總金額：",
    "Pay the remaining time": "支付剩餘時間", //支付剩余时间
    Order: "訂單",
    createTime: "時間",
    "Service amount": "服務費：",
    "Bill Decimal": "賬單小數：",
    "Invite details": "自取詳情",
    package_detail: "套票詳情", // Details
    "Order cancelled": "訂單已取消",
    "Go to view": "前往查看",
    "Order Details": "訂單詳情", //訂單詳情
    "Order No": "訂單編號",
    "Solitary time": "落單時間", //落單時間
    // ! 2023-10-31
    Reminder: "溫馨提示",
    QRCode: "固定碼詳情",
    StoreOrder: "店鋪訂單詳情",
    SkyOrder: "掃碼點餐詳情",
    PriorOrder: "預點餐詳情",
    UsedCoupon: "使用優惠券",
    "Member Discounts": "會員等級折扣",
    "Restaurant Discounts": "餐廳折扣",
    "Automatic Discounts": "自動折扣",
    Coupons: "優惠券",
    Wait: "等待支付",
    "Payment completed": "支付完成",
    Remaining: "剩餘",
    "Coupons have been distributed": "優惠券已發放",
    'Location: HomePage → "..." in the upper right corner → My coupons':
      "存放在：首頁 → 右上角“...” → 我的優惠券",
    Details: "查看明細",
    "View more discounts：Ricepon App -> Coupon":
      "更多優惠請至 飯糰APP-優惠券 查看",
    "Please complete payment within X minutes":
      "{X}分鐘內未支付，訂單將自動取消",
    "Save screenshot to photo album": "截取熒幕保存優惠券到你嘅電話",
    "so you won’t lose it.": "咁就唔怕整唔見啦",
    "Save coupon to album": "保存優惠券到你嘅相冊",
    "Save coupon to album2": "保存優惠券到相冊",
    "Copied successfully": "複製成功",
    "The browser doesn’t support auto-copy.": "該瀏覽器不支持自動複製",
    "QR code": "二維碼",
    Paid: "已支付",
  },
  myCoupon: {
    "My coupon": "我的優惠券",
    Coupon: "我的優惠券",
    Available: "可使用",
    "Please enter the discount code to redeem": "請輸入優惠碼兌換",
    Used: "已使用",
    Expired: "已過期",
    "Redemption successful": "已成功領取優惠券",
    "Check coupon status via WhatsApp": "通過WhatsApp查看優惠券狀態",
    Cancel: "取消",
    to: "至",
    price: "金額",
  },
  couponDetail: {
    "Valid Min order of HK$X": "滿{X}可用",
    "X Sold": "{X}人購買",
    "X Redeemed": "{X}人領取",
    "X Redeemed2": "已領{X}",
    "Includes X Coupons": "内含 {X} 張優惠券",
    "All shop": "所有門店適用",
    "Only designated shop": "指定門店適用",
    "Valid until:": "有效期：",
    "Available X days ": "購買後{X}天內可用",
    "More Coupon": "更多優惠券",
    "Valid until2:": "套票有效期",
    "Terms and Conditions": "條款及細則",
    "More Terms and Conditions": "更多條款及細則",
    "Valid until3:": "優惠券有效期",
    "Available X days": "領取後{X}天可用",
    "Related offers": "相關優惠",
    "Only X coupons left": "僅剩{X}張",
    Redeemed: "已領取",
    "Use Now": "去使用",
    "Sold Out": "已售罄",
    "Redeem Now": "立即領取",
    "Welcome Offer": "迎新優惠",
    "Join Member": "加入會員",
    Buy: "購買",
    "X Shop Available": "查看{X}家可用分店",
    "No address": "暫無地址資訊！",
    "By placing your order, you agree to the Terms and Conditions":
      "購買即表示您已細閱並同意",
    "Event Terms of Service": "活動服務條款",
    "I have read and agree X & Y": "我已閱讀並同意《{X}》及 {Y}",
    "I have read and agree": "同意並閲讀",
    Confirm: "確認",
    Back: "返回",
  },
  refresh: {
    refreshUp: "下拉可以刷新", //下拉可以刷新
    "Release refresh": "釋放立即刷新", //釋放立即刷新
    Refreshing: "正在刷新...", //正在刷新...
    "Successfully loaded": "加載成功",
    "Pull-up shows more": "上拉顯示更多", //上拉顯示更多
    "Loading...": "正在加載...", //正在加載
    "No more data": "沒有更多數據了", //沒有更多數據了
  },
  myAddress: {
    "Add address": "添加地址",
  },
  message: {
    "Collection successful": "收藏成功!",
    "Canceled favorites": "取消成功!",
    and: "及",
    selfBrand: "本品牌",
    "Brand Agreement": "品牌協議",
    "Ricepon Agreement": "Ricepon協議",
    Loading: "加載中...",
  },
  login: {
    "Bind mobile number": "綁定手機號碼",
    "Successful SMS Sending!": "短信發送成功!",
    "Binding success!": "綁定成功!",
    "Enter a correct Phone Number": "請輸入正確的手機號碼",
    "Phone number": "請輸入手機號碼",
    "Enter verification code": "請輸入驗證碼",
    "Send verify code": "取得驗證碼",
    "phone number2": "手機號碼",
    Captcha: "驗證碼",
    Confirm: "確認",
    "SMS verification code error": "短信驗證碼錯誤!",
    "Member login error times too many, please try again later":
      "會員登錄錯誤次數太多,請稍後重試!",
    "Your account has been suspended, please contact customer service email!":
      "帳戶已暫停，請聯絡客戶服務email!",
    "Network request timeout! Please refresh and try again!":
      "網絡請求超時!請刷新後重試!",
    "Your account hasexpired, please contact customer service email!":
      "帳戶已過期，請聯絡客戶服務email!",
    // 2024-3-14 14:46:52
    "Binding Mobile Phone Number": "綁定手機號",
    "phone number 2": "手機號",
    "Phone number": "請輸入手機號",
    bindSuccess: "綁定成功!",
    Back: "返回",
    Agree: "同意",
    googleBindTitle: "綁定 Google 帳戶",
    googleBindSubtitle:
      "麻煩你先綁定一次，以後就可以直接用 Google 登錄，唔使再收短信驗證碼。",
    googleBindAccountName: "Google 帳戶",
    googleBindAccountLinked: "Google 帳戶已連結",
    googleBindWithSms: "短信綁定",
    googleBindWithPassword: "密碼綁定",
    googleBindPasswordLabel: "密碼",
    googleBindPasswordPlaceholder: "請輸入密碼",
    googleBindHelpTitle: "需要幫助？",
    googleBindHelpText:
      "如你已設置密碼，可直接使用密碼綁定；如未註冊或未設置密碼，也可使用短信方式完成註冊或綁定。",
    googleBindExpired: "Google 綁定已失效，請重新登入 Google",
    googleBindInvalidPhone: "請輸入正確的手機號碼",
    googleBindPasswordRequired: "請輸入密碼",
    googleBindFailed: "Google 綁定失敗",
    googleBindPasswordFailed: "密碼綁定失敗",
    googleBindSuccess: "綁定成功",
    googleBindContinue: "繼續",
    googleBindBusy: "操作過於頻繁，請稍後再試",
    googleMemberNotFound: "找不到會員資料，請稍後再試",
    googleAccountAlreadyBound: "此 Google 帳戶已綁定其他帳號",
    googleMemberAlreadyBoundOther: "此會員已綁定另一個 Google 帳戶",
    googleLoginFailed: "Google 登錄失敗",
    googleLoginFailedRetry: "Google 登錄失敗，請改用密碼或短信登錄",
    googleLoginUnavailable: "Google 登錄暫時不可用",
    googleOpenInBrowser:
      "當前頁面所在瀏覽器不支援 Google 登錄，請點右上角以系統瀏覽器開啟後再試",
    googleNeedAgree: "請先同意條款",
    googleAgreeAndContinue: "需要先同意條款，是否同意並繼續 Google 登錄？",
    googleAgreeAndContinuePrefix: "是否同意",
    googleAgreeAndContinueSuffix: "並繼續 Google 登錄？",
    googleClientIdTip: "配置 VUE_APP_GOOGLE_CLIENT_ID 後即可使用 Google 登錄。",
    googleRecommended: "推薦使用 Google 登錄",
    googleRecommendedDesc: "無需等待短信，登入與綁定會更快完成。",
    googleButtonLabel: "使用 Google 帳戶登入",
    Use_Google_or_WhatsApp_to_log_in_quickly: "使用 Google 或 WhatsApp 快速登入",
    Use_WhatsApp_to_log_in: "使用 WhatsApp 登入",
    SMS_login: "SMS 登入",
    WhatsApp_login_register: "WhatsApp登入/註冊",
    Enter_WhatsApp_phone_number: "請輸入 WhatsApp 手機號碼",
    Enter_WhatsApp_verification_code: "請輸入 WhatsApp 驗證碼",
    googleConfirmTitle: "Google登入/註冊",
    googleConfirmSubtitle: "同意協議並使用Google授權登錄",
    googleConfirmCancel: "再想想",
    googleConfirmAgree: "我同意",
    googleAltLogin: "或使用短信登入",
    googleLoading: "正在載入 Google 登錄…",
    googleRedirecting: "正在跳轉到 Google…",
    bindMobileDescription: "使用WhatsApp快速登錄",
    unregisteredAutoRegister: "未註冊手機號將自動創建賬號",
    smsLoginLabel: "短信登錄",
    passwordLoginLabel: "密碼登錄",
    loginActionText: "登錄",
    whatsappVerifyLogin: "WhatsApp 驗證登錄",
    safeAuthTip: "快速、安全、一鍵授權",
    passwordSafeTip: "使用密碼安全登錄",
    switchOtherMethods: "或切換其他方式",
    forgotPasswordLabel: "忘記密碼?",
    pasteOtpConfirm: "是否粘貼{code}?",
    nextStep: "下一步",
    registerLogin: "註冊/登入",
    welcomeTo: "歡迎來到",
    memberRewardsTip: "成為會員儲積分，尊享優惠~",
    passwordLogin: "密碼登入",
    smsLogin: "驗證碼登入",
    forgotPassword: "忘記密碼?",
    pleaseEnterPassword: "請輸入密碼",
    pleaseAgreeAgreement: "請同意協議",
    loginSuccess: "登入成功",
    retrievePassword: "找回密碼",
    forgotPasswordPrompt: "忘記密碼？可以通過電話號碼找回哦!",
    setPassword: "設置密碼",
    pleaseSetPassword: "請設置密碼",
    confirmPassword: "確認密碼",
    pleaseConfirmPassword: "請確認密碼",
    phoneIncorrect: "手機號不正確",
    passwordsNotMatch: "密碼不一致",
    passwordResetSuccess: "密碼重置成功",
    passwordResetFailed: "密碼重置失敗",
    next: "下一步",
    step2SetPassword: "2/3 設置密碼以便後續登入",
    passwordLengthGt6: "密碼長度需大於6位",
    confirmPasswordNotMatch: "確認密碼與密碼不一致",
    completeRegistration: "完成註冊",
    completeProfile: "完善個人資料",
    step3CompleteProfile: "3/3 完善個人資料，獲得更好的服務~",
    memberName: "會員名稱",
    pleaseEnterMemberName: "請輸入會員名稱",
    gender: "性別",
    male: "男",
    female: "女",
    birthday: "出生日期",
    pleaseSelectBirthday: "請選擇出生日期",
    pleaseEnterEmail: "請輸入郵箱地址",
    selectDate: "选择年月日",
    pleaseSelectGender: "請選擇性別",
    networkRetryLogin: "網絡開小差了,請重試登錄!",
    registrationExpired: "註冊信息已過期,請重新註冊!",
    updateProfileSuccess: "修改信息成功",
    welcomeBack: "歡迎回來",
    platformPoweredByRicepon: "本平臺由飯糰Ricepon提供技術支持",
    riceponAccountSyncDesc:
      "檢測到您已是 飯糰Ricepon 的用戶，為讓您快速開始，我們將為您同步賬戶資訊。",
    dataSource: "數據來源",
    dataSourceDesc:
      "您在本站看到的個人資料與優惠券等資訊，由飯糰Ricepon 安全提供。",
    privacySecurity: "隱私安全",
    privacySecurityDesc:
      "我們與 飯糰Ricepon 共同嚴格守護您的數據安全，僅用於為您提供本服務。",
    smsCodeError: "短信驗證碼錯誤",
    memberLoginErrorTooMany: "會員登錄錯誤次數太多,請稍後重試!",
    accountSuspended: "帳戶已暫停，請聯絡客戶服務email!",
    accountExpired: "帳戶已過期，請聯絡客戶服務email!",
    phoneNumberLabel: "電話號碼",
    passwordLabel: "密碼",
    enterPhoneNumber: "請輸入電話號碼",
    enterVerificationCode: "請輸入驗證碼",
    enterCorrectPhone: "請輸入正確的手機號",
    captchaLabel: "驗證碼",
    sendVerifyCode: "取得驗證碼",
    resendVerifyCode: "重新取得驗證碼",
    sendCodeFailed: "發送驗證碼失敗",
    pleaseSendVerificationCode: "請點送驗證碼",
    verificationCodeFormatError: "驗證碼格式錯誤",
    verificationPassed: "通過校驗",
    googleBindTitle: "綁定 Google 帳戶",
    googleBindSubtitle: "麻煩你先綁定一次，以後就可以直接用 Google 登錄，唔使再收短信驗證碼。",
    googleBindAccountName: "Google 帳戶",
    googleBindAccountLinked: "Google 帳戶已連結",
    googleBindWithSms: "短信綁定",
    googleBindWithPassword: "密碼綁定",
    googleBindPasswordLabel: "密碼",
    googleBindPasswordPlaceholder: "請輸入密碼",
    googleBindHelpTitle: "需要幫助？",
    googleBindHelpText:
      "如你已設置密碼，可直接使用密碼綁定；如未註冊或未設置密碼，也可使用短信方式完成註冊或綁定。",
    googleBindExpired: "Google 綁定已失效，請重新登入 Google",
    googleBindInvalidPhone: "請輸入正確的手機號碼",
    googleBindPasswordRequired: "請輸入密碼",
    googleBindFailed: "Google 綁定失敗",
    googleBindPasswordFailed: "密碼綁定失敗",
    googleBindSuccess: "綁定成功",
    googleBindContinue: "繼續",
    googleBindBusy: "操作過於頻繁，請稍後再試",
    googleMemberNotFound: "找不到會員資料，請稍後再試",
    googleAccountAlreadyBound: "此 Google 帳戶已綁定其他帳號",
    googleMemberAlreadyBoundOther: "此會員已綁定另一個 Google 帳戶",
    googleLoginFailed: "Google 登錄失敗",
    googleLoginFailedRetry: "Google 登錄失敗，請改用密碼或短信登錄",
    googleLoginUnavailable: "Google 登錄暫時不可用",
    googleOpenInBrowser: "當前頁面所在瀏覽器不支援 Google 登錄，請點右上角以系統瀏覽器開啟後再試",
    googleNeedAgree: "請先同意條款",
    googleAgreeAndContinue: "需要先同意條款，是否同意並繼續 Google 登錄？",
    googleAgreeAndContinuePrefix: "是否同意",
    googleAgreeAndContinueSuffix: "並繼續 Google 登錄？",
    googleClientIdTip: "配置 VUE_APP_GOOGLE_CLIENT_ID 後即可使用 Google 登錄。",
  googleRecommended: "推薦使用 Google 登錄",
  googleRecommendedDesc: "無需等待短信，登入與綁定會更快完成。",
    googleButtonLabel: "使用 Google 帳戶登入",
    googleConfirmTitle: "Google登入/註冊",
    googleConfirmSubtitle: "同意協議並使用Google授權登錄",
    googleConfirmCancel: "再想想",
    googleConfirmAgree: "我同意",
    googleAltLogin: "或使用短信登入",
    googleLoading: "正在載入 Google 登錄…",
    googleRedirecting: "正在跳轉到 Google…",
    bindMobileDescription: "使用WhatsApp快速登錄",
    unregisteredAutoRegister: "未註冊手機號將自動創建賬號",
    smsLoginLabel: "短信登錄",
    passwordLoginLabel: "密碼登錄",
    loginActionText: "登錄",
    whatsappVerifyLogin: "WhatsApp 驗證登錄",
    safeAuthTip: "快速、安全、一鍵授權",
    passwordSafeTip: "使用密碼安全登錄",
    switchOtherMethods: "或切換其他方式",
    forgotPasswordLabel: "忘記密碼?",
    pasteOtpConfirm: "是否粘貼{code}?",
    nextStep: "下一步",
  },
  payPopup: {
    RefreshPaymentResult: "刷新支付結果",
    Paying: "正在支付",
    "Submitted, please wait patiently": "訂單已提交,請您耐心等待",
    Cancelled: "取消支付",
    "Cancellation failed": "取消失敗",
    Paid: "訂單已支付",
  },
  map: {
    "Please enable location permission in browser settings":
      "請在瀏覽器設置中打開定位用以定位",
    "The request for location was denied.": "用戶拒絕對獲取地理位置的請求。",
    "Location is unavailable.": "位置資訊是不可用的。",
    "The request for location timed out.": "請求用戶地理位置超時。",
    "Unknown error.": "未知錯誤。",
    "Current browser does not support getting location":
      "該瀏覽器不支持獲取地理位置",
    View_Google_Navigation: "查看Google導航",
  },
  area: {
    HongKong: "中國香港",
    Singapore: "新加坡",
    Macau: "中國澳門",
    China: "中國大陸",
    Japan: "日本",
    Korea: "韓國",
    Thailand: "泰國",
  },
  invite: {
    submitted: "已提交",
    "Merchant has confirmed": "商戶已確認",
    "Meal available": "可以取餐",
    Tel: "收貨電話",
    "Please wait patiently for the merchant to confirm, and pick up the meal according to the meal code. If the meal code is not displayed, please try to refresh":
      "請耐心等待商家確定,憑取餐碼取餐,如取餐碼未顯示請嘗試刷新",
    "Contact merchant": "聯絡餐廳", //联系商家
    Cancelled: "已取消",
    "Subscribe to notification messages using WhatsApp":
      "是否跳轉 WhatsApp 完成訂閱",
  },
  confirm: {
    Warm_prompt: "溫馨提示",
    cap_Confirm: "確認",
  },
  account: {
    昵称: "暱稱",
    修改昵称: "修改暱稱",
    请输入昵称: "請輸入暱稱",
    邮件: "郵件",
    修改邮件: "修改郵件",
    请输入邮件: "請輸入郵件",
    请输入正确的邮件地址: "請輸入正確的郵件地址",
    生日: "生日",
    修改生日: "修改生日",
    修改成功: "修改成功",
    温馨提示: "溫馨提示",
    品牌协议: "品牌協議",
    切换语言: "切換語言",
    登出: "登出",
    登入: "登入",
    请先登入: "請先登錄~",
    切换字体: "切換字體",
  },
  tabBar: {
    首页: "首頁",
    点单: "點單",
    订单: "訂單",
    账户: "賬戶",
  },
  tabBarBrand: "品牌",
  pay: {
    支付金额应大于0: "支付金額應大於0",
  },
  order: {
    更多: "更多...",
    共X份: "共{x}份,總金額: {n}",
    取消订单: "取消訂單",
    申请退款: "申請退款",
    联络餐厅: "聯絡餐廳",
    去支付: "去支付",
    退款进度: "退款進度：",
    取消原因: "取消原因：",
    堂食: "堂食",
    外送: "外送",
    自取: "自取",
    冷冻派送: "冷凍派送",
    待支付: "待支付",
    已提交: "已提交",
    待确认: "待確認",
    製作中: "製作中",
    待取餐: "待取餐",
    已完成: "已完成",
    已取消: "已取消",
    外卖自取: "外賣自取",
    取餐信息: "取餐信息",
    评价: "評價",
    订单码: "訂單碼",
    投票: "投票",
    投票历史: "投票歷史",
    商家已确认不可取消: "商家已確認,不可取消",
    取消成功: "取消成功!",
    确定取消订单: "確定取消訂單?",
    等待确认: "等待確認",
    等待付款: "等待付款",
    订单已完成: "訂單已完成",
    待取餐: "待取餐",
    派送中: "派送中",
    已送达: "已送達",
    退款处理中: "退款處理中",
    预计5到7天内退款完成: "預計5-7天內退款完成",
    预计1到3个工作日内退款完成: "預計1-3個工作日內退款完成",
    退款已完成: "退款已完成",
    退款中: "退款中",
    外卖订单: "外送訂單",
    店铺订单: "店鋪訂單",
    扫码点餐: "掃碼點餐",
    已完结: "已完結",
    购买等级: "購買等級",
    已取餐: "已取餐",
    團購券: "團購券",
    可使用: "可使用",
  },
  orderList: {
    all: "全部",
    pendingPayment: "待付款",
    toBeEvaluatedOrVoted: "點評/投票",
    loading: "加載中...",
    empty: "暫時沒有訂單",
  },
  barcode: {
    可前往埋單機掃賬單碼支付訂單: "可前往埋單機掃賬單碼支付訂單",
    點擊查看賬單碼: "點擊查看賬單碼",
    請到埋單機掃下方賬單碼支付訂單: "請到埋單機掃下方賬單碼支付訂單",
    賬單碼: "賬單碼",
  },
  couponTag: {
    減: "減",
    OFF: "OFF",
  },
  mealFood: {
    加购享优惠: "加購享優惠",
    撞餐優惠金額結賬時進行計算: "撞餐優惠金額結賬時進行計算",
  },
  queue: {
    暂不支持X取号: "暫不支持 {X} 等級取號!",
    取号记录: "取號記錄",
    还需等待x桌: "還需等待{X}桌",
    排队中: "輪候中",
    呼叫中: "呼叫中",
    已过号: "已過號",
    已入座: "已入座",
    已取消: "已取消",
    请耐心等候: "請稍候片刻，我們馬上為您安排!",
    请与餐厅职员联络:
      "唔好意思，餐廳已暫停取號服務。如有疑問，請與餐廳職員聯絡。",
    优先轮候: "優先輪候",
    普通会员: "普通會員",
    X优先取票: "“{X}”優先取票",
    您的会员等级不足: "您的會員等級不滿足",
    仅支持X优先轮候: "僅支持{X}優先輪候",
    知道了: "關閉",
    温馨提示: "溫馨提示",
    超出限制: "您在當前餐廳輪候號碼已超過限制 請前往取消後再試",
    已取过号了: "你已經在{X}餐廳取號輪候 是否取消此餐廳的輪候？",
    再想想: "再想想",
    取消排队: "取消輪候",
    请选择用餐时段: "請選擇用餐時段",
    取消成功: "取消成功",
    网络似乎开小差了: "網絡似乎開小差了，請稍後再試!",
    补票中: "補票中",
    未齐人号码保留中: "保留中",
    餐厅优惠: "餐廳優惠",
    更多: "更多",
    公告: "公告",
    请输入用餐人数: "請輸入用餐人數",
    请输入会员Id: "請輸入美高梅會員號碼",
    取号成功: "取號成功",
    请通过以下方式获取排队进度提醒: "請選擇以下獲取輪候狀態方式",
    请选择以下获取排队提醒方式: "請選擇以下獲取輪候提醒方式",
    微信通知: "微信通知",
    获取短信提醒: "獲取訊息提醒",
    请输入你要获取排队动态的电话号码:
      "請輸入你希望用作接收輪候狀態提示的手機號碼。",
    确定: "確 定",
    请输入正确的手机号: "請輸入正確的手機號",
    微信订阅成功: "微信訂閱成功",
    微信订阅失败: "微信訂閱失敗",
    短信订阅成功: "訊息訂閱成功",
    短信订阅失败: "訊息訂閱失敗",
    跳过: "跳過",
    获取排队通知: "避免錯過入座時機,請獲取輪候通知",
    餐厅地址: "餐廳地址",
    餐厅名称: "餐廳名稱",
    用餐人数: "用餐人數",
    取号时间: "取號時間",
    X人: "{X}人",
    联络电话: "聯絡電話",
    用餐号: "用餐號",
    是否确认取消轮候: "是否確認取消輪候？",
    MGM_确认取消: "確認取消",
    MGM_否: "否",
    X人: "{X}人",
    X人以上: "{X}人以上",
    X到Y人: "{X}~{Y}人",
    点击这里以短讯接收通知: "點擊這裡以短訊接收通知",
    接收短讯可能产生电讯商费用: "(接收短訊可能產生電訊商費用)",
    获取提醒表示接受X: "獲取提醒表示接受《{X}》",
    私隐条款: "私隱條款",
  },
  WhatsApp: {
    感谢惠顾: "感謝惠顧",
    X为你送上Y张优惠券: "{X}為你送上 {Y} 張優惠券",
    前往领取: "前往領取",
    S后自动取号: "{X}S後自動取消取號",
  },
};
export default hk;





